<template>
  <section class="co-bg-striped px-4 py-5">
    <div class="co-container-xs">
      <a
        href="#careerup"
        @click.prevent="scrollTo('careerup')"
      >
        <img
          src="~/assets/images/Te/TeCourse/Ordermade/Banner/reskill-banner.svg"
          width="655"
          height="106"
          loading="lazy"
          alt="受講料最大70%OFF"
          class="mx-auto"
        >
      </a>
    </div>
  </section>
</template>
